import React from 'react';
import { useTranslation } from 'react-i18next';
import { KeyRound } from 'lucide-react';
import { useBotSecretsQuery } from '../../hooks/queries';
import { useDeleteSecret } from '../../hooks/mutations';
import { PanelList, PanelRow, PanelSection, RemoveButton } from './panel/PanelKit';

/** Logins people let the project's bots remember (names only; values stay encrypted). */
const SavedLogins = ({ projectId }) => {
  const { t } = useTranslation();
  const { data } = useBotSecretsQuery(projectId);
  const remove = useDeleteSecret();
  const rows = data?.secrets || [];
  if (rows.length === 0) return null;
  return (
    <PanelSection title={t('bots.secrets.saved_title')} count={rows.length} data-testid="saved-logins">
      <PanelList>
        {rows.map((s) => (
          <PanelRow key={s.id} icon={<KeyRound className="w-3.5 h-3.5" />} title={s.label}
            trailing={<RemoveButton onClick={() => remove.mutate(s.id)} title={t('bots.secrets.remove')} />} />
        ))}
      </PanelList>
    </PanelSection>
  );
};

export default SavedLogins;
